<template>
  <div>
    <Navigation/>
    <div class="bg_box">
      <div class="noneBox"></div>
      <div class="box">
        <p class="back" @click="$router.push('/wordNav')">返回</p>
        <div class="ct_box flex">
          <div class="form_upload_box">
            <ai_title ai_title="“智能生成”_文稿润色"/>
            <select_model @getModelStyle="getModelStyle"></select_model>
            <p class="from_title_new">生成文稿润色</p>

            <div class="transparent_box">
              <ai_upload @get_url="get_url"/>
              <!-- <ai_select upLoad_text_align="left" :minWidth="60" selectTitle="类型" :select_list='style_list'
                  @getSelectVal="getStyle" /> -->
              <ai_button_file_data ref="ai_button_file_data" @file_data="file_data"/>
              <ai_text_content :contentData="contentData"/>
            </div>


          </div>
          <wordNav/>
          <aiNum title="计费规则：1000tokens = 0.9元，" text="1000tokens在700-750字左右" :visible="aiNumShow"
                 @close="aiNumShow = false" @postData="postData"/>
          <aiPoup :visible="aiPoupShow" @close="aiPoupShow = false"/>
        </div>
      </div>
    </div>
    <footerBot/>
  </div>
</template>

<script>
import wordNav from '@/components/wordNav'
import ai_title from '@/components/ai_title'
import ai_upload from '@/components/ai_upload'
import ai_select from '@/components/ai_select'
import ai_button_file_data from '@/components/ai_button_file_data'
import ai_text_content from '@/components/ai_text_content'
import select_model from "@/components/select_model.vue";

export default {
  mounted() {
    this.getUserInfo()
  },
  components: {
    select_model,
    wordNav,
    ai_title,
    ai_upload,
    ai_select,
    ai_button_file_data,
    ai_text_content
  },
  data() {
    return {
      // 模型选择
      model_style: 1,
      //type: '', // 行业
      //business: '',// 擅长领域
      //personal: '',// 个人荣誉
      style_list: [
        {
          id: 0,
          name: '缩写'
        },
        {
          id: 1,
          name: '延申'
        },
      ],
      form: {
        keyword: '', // 关键词
        style: '',
      },

      contentData: {},
      aiNumShow: false,
      aiPoupShow: false,
    }
  },
  methods: {
    getModelStyle(data) {
      this.model_style = data
    },
    get_url(url) {
      this.form.keyword = url
    },
    getStyle(val) {
      this.form.style = val
    },
    getUserInfo() {
      let $user_info = JSON.parse(localStorage.getItem('user_info'))
      if ($user_info) {
        this.curlGet('/api/user/info').then((res) => {
          if (res.data.code) {
            this.$user_info = res.data.data
            this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
          }
        })
      }
    },
    file_data() {
      if (this.model_style === 1) {
        this.postData()
        return
      }
      if (this.$user_info.money <= 0) {
        this.aiPoupShow = true
      } else {
        this.aiNumShow = true
      }

    },
    postData() {
      if (this.keyword != '') {
        this.aiNumShow = false
        this.$refs.ai_button_file_data.loading_show()
        this.curlPost('file/article_polish', {
          mobile: this.$user_info.mobile,
          input_text: this.form.keyword,
          // style: this.form.style,
          model_style: this.model_style
        }).then(res => {
          this.$refs.ai_button_file_data.loading_show()
          if (res.data.code) {
            this.contentData = res.data.data
            // 扣费
            this.curlPost('/api/users/money_log/spend', {
              ai_id: res.data.data.id,
              amount: res.data.data.money,
            }).then(res => {
              if (res.data.code) {
                this.getUserInfo()

              }
            })
          }
        })
      } else {
        this.aiNumShow = false
        return this.$message({
          message: '禁止上传空文件!',
          type: 'warning',
          offset: 80
        });
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res);

      if (res.code == 1) {
        this.keyword = res.data.content
      } else {
      }

    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    uploadFn(response, file, fileList) {
      console.log(response, file, fileList);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    err(err, file, fileList) {
      console.log(err, file, fileList);
    },
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/ai';
</style>